module.exports = __webpack_public_path__ + "img/Arrow_Down_white.08fb1e87.svg";